/* ------------------------------------------------------------------
   Google Rating badge (Elfsight) — dismissible.
   The badge renders asynchronously, so we watch for its card, inject a
   close (×) button, and remember the dismissal in localStorage so it
   stays hidden on future visits.
   ------------------------------------------------------------------ */
(function () {
  var APP_CLASS = 'elfsight-sapp-1d054fef-66f6-49bc-96dc-29e6cdfe7929';
  var STORAGE_KEY = 'kjHideGoogleReviewBadge';

  function getContainer() {
    return document.querySelector('.' + APP_CLASS);
  }

  function hideBadge(persist) {
    var el = getContainer();
    if (el) el.style.display = 'none';
    if (persist) {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
  }

  function addButton(card) {
    if (card.querySelector('.kj-review-dismiss')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kj-review-dismiss';
    btn.setAttribute('aria-label', 'Hide reviews');
    btn.innerHTML = '&times;';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hideBadge(true);
    });
    card.appendChild(btn);
  }

  function init() {
    // Previously dismissed → hide immediately and stop.
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        hideBadge(false);
        return;
      }
    } catch (e) {}

    var container = getContainer();
    if (!container) return;

    var card = container.querySelector('[class*="BadgeLayout__Inner"]');
    if (card) { addButton(card); return; }

    // Card renders asynchronously; watch for it (re-adds if Elfsight
    // re-renders during load). Guard prevents duplicate buttons.
    var observer = new MutationObserver(function () {
      var c = container.querySelector('[class*="BadgeLayout__Inner"]');
      if (c) addButton(c);
    });
    observer.observe(container, { childList: true, subtree: true });

    // Stop watching once the badge has had time to settle.
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
